import { generateUuid } from "./id.utils";
import { seconds } from "./time.utils";
import { doEvery } from "./waiters.utils";

let token = generateUuid();
export const getTrustToken = () => token;
doEvery(() => {
  token = generateUuid();
}, seconds(10));